import { KlientkontoerklaeringFormValues } from "../../interfaces/klientkontoerklaering";
import { guid } from "../../util/string";

export const KKE_FORM_INITIAL_VALUES: KlientkontoerklaeringFormValues = {
  advokatens_section_1_1_samleklientbankkonti: [
    { pengeinstitution: "", regKontoNr: "", opretDato: "", cvrKonto: "" },
  ],
  advokatens_section_1_2_bogføringssystem: "",
  advokatens_section_1_3_aabningsdag: "",
  advokatens_section_1_4_dispensation_ja_nej: "",
  advokatens_section_1_5_dispensationDato: "",
  advokatens_section_1_5_dispensationSagsnr: "",
  advokatens_section_1_5_dispensationPeriodeDatoFra: "",
  advokatens_section_1_5_dispensationPeriodeDatoTil: "",
  advokatens_section_1_6_bogføringAntalDage: undefined,
  advokatens_section_2_1_samletKlienttilsvar_input: "",
  advokatens_section_2_1_samletKlienttilsvar_beloeb: undefined, // dependant on advokatens_section_2_1_samletKlienttilsvar_input
  advokatens_section_2_2_indestaaende_input: "",
  advokatens_section_2_2_indestaaende_beloeb: undefined,
  advokatens_section_2_3_ingen_regulering: false,
  advokatens_section_2_3_forMeget_forLidt: undefined,
  advokatens_section_2_3_forMegetellerLidtIndestaaende_input: "",
  advokatens_section_2_3_forMegetellerLidtIndestaaende_beloeb: undefined,
  advokatens_section_2_3_haevet_indsat: "",
  advokatens_section_2_3_haevet_indsat_dato: "",
  advokatens_section_3_1_pengeinstitut_indestaende_input: "",
  advokatens_section_3_1_pengeinstitut_indestaende_beloeb: undefined,
  advokatens_section_3_3: {
    advokatens_section_3_3_a_beloeb: undefined,
    advokatens_section_3_3_a_input: "",
    advokatens_section_3_3_a_plus_minus: "-",
    advokatens_section_3_3_b_beloeb: undefined,
    advokatens_section_3_3_b_input: "",
    advokatens_section_3_3_b_plus_minus: "-",
    advokatens_section_3_3_c_beloeb: undefined,
    advokatens_section_3_3_c_input: "",
    advokatens_section_3_3_c_plus_minus: "-",
    advokatens_section_3_3_d_beloeb: undefined,
    advokatens_section_3_3_d_input: "",
    advokatens_section_3_3_d_plus_minus: "+",
    advokatens_section_3_3_e_beloeb: undefined,
    advokatens_section_3_3_e_input: "",
    advokatens_section_3_3_e_plus_minus: "+",
    advokatens_section_3_3_e_beskrivelse: "",
  },
  revisors_0_intro_overholder_revisorloven: undefined,
  revisors_0_intro_aftalebrev_indgået: undefined,
  revisors_handling_1_question: undefined,
  revisors_handling_1_question_alt_2_samleklientbankkonti: undefined,
  revisors_handling_1_question_alt_3_samleklientbankkonti: undefined,
  revisors_handling_1_question_alt_4_beskrivelse: undefined,
  revisors_handling_2_question: undefined,
  revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover: undefined,
  revisors_handling_2_question_alt_3: undefined,
  revisors_handling_2_alt_3_antal_bokonti_ikke_opprettet_i_kurators_bobestyrers_advokatselskabets_navn:
    undefined,
  revisors_handling_2_alt_3_antal_bokonti_ikke_opprettet_i_boets_navn:
    undefined,
  revisors_handling_2_alt_3_antal_bokonti_stikprover: undefined,
  revisors_handling_2_alt_3_antal_bokonti_ikke_separate: undefined,
  revisors_handling_2_alt_3_bemaerkning: undefined,
  revisors_handling_2_alt_3_antal_bokonti_ikke_oprettet: undefined,
  revisors_handling_3_question: undefined,
  revisors_handling_3_alt_2_bogfoeringssystem: undefined,
  revisors_handling_4_revisionsbesoeg_dato: undefined,
  revisors_handling_4_question: undefined,
  revisors_handling_4_alt_2_uddybning: undefined,
  revisors_handling_5_question: undefined,
  revisors_handling_5_alt_2_beskriv_uoverenstemmelsen: undefined,
  revisors_handling_6_question: undefined,
  revisors_handling_6_alt_2_dato_reguleret: undefined,
  revisors_handling_6_alt_2_forklaring: undefined,
  revisors_handling_6_alt_3_uddybning: undefined,
  revisors_handling_7_question: undefined,
  revisors_handling_7_alt_2_beskrivelse: undefined,
  revisors_handling_8_question: undefined,
  revisors_handling_8_alt_2_beskrivelse: undefined,
  revisors_handling_9_question: undefined,
  revisors_handling_9_alt_2_beskrivelse: undefined,
  revisors_handling_10_question: undefined,
  revisors_handling_10_alt_1_dispensationDato: undefined,
  revisors_handling_10_alt_1_dispensationPeriodeDatoFra: undefined,
  revisors_handling_10_alt_1_dispensationPeriodeDatoTil: undefined,
  revisors_handling_10_alt_2_uddybning: undefined,
  revisors_handling_11_periode_fra: undefined,
  revisors_handling_11_periode_til: undefined,
  revisors_handling_11_question: undefined,
  revisors_handling_11_alt_2_uddybning: undefined,
  revisors_handling_12_table: [
    {
      revisors_handling_12_table_columns_dato: undefined,
      revisors_handling_12_table_column_samlet_tilsvar_beloeb: undefined,
      revisors_handling_12_table_column_samlet_tilsvar_input: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_beloeb: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_input: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_plus_minus: "+",
      revisors_handling_12_table_column_reguleringsdato: undefined,
      revisors_handling_12_table_column_mellemvaerende_beloeb: undefined,
      revisors_handling_12_table_column_mellemvaerende_input: undefined,
    },
    {
      revisors_handling_12_table_columns_dato: undefined,
      revisors_handling_12_table_column_samlet_tilsvar_beloeb: undefined,
      revisors_handling_12_table_column_samlet_tilsvar_input: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_beloeb: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_input: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_plus_minus: "+",
      revisors_handling_12_table_column_reguleringsdato: undefined,
      revisors_handling_12_table_column_mellemvaerende_beloeb: undefined,
      revisors_handling_12_table_column_mellemvaerende_input: undefined,
    },
    {
      revisors_handling_12_table_columns_dato: undefined,
      revisors_handling_12_table_column_samlet_tilsvar_beloeb: undefined,
      revisors_handling_12_table_column_samlet_tilsvar_input: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_beloeb: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_input: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_plus_minus: "+",
      revisors_handling_12_table_column_reguleringsdato: undefined,
      revisors_handling_12_table_column_mellemvaerende_beloeb: undefined,
      revisors_handling_12_table_column_mellemvaerende_input: undefined,
    },
    {
      revisors_handling_12_table_columns_dato: undefined,
      revisors_handling_12_table_column_samlet_tilsvar_beloeb: undefined,
      revisors_handling_12_table_column_samlet_tilsvar_input: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_beloeb: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_input: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_plus_minus: "+",
      revisors_handling_12_table_column_reguleringsdato: undefined,
      revisors_handling_12_table_column_mellemvaerende_beloeb: undefined,
      revisors_handling_12_table_column_mellemvaerende_input: undefined,
    },
    {
      revisors_handling_12_table_columns_dato: undefined,
      revisors_handling_12_table_column_samlet_tilsvar_beloeb: undefined,
      revisors_handling_12_table_column_samlet_tilsvar_input: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_beloeb: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_input: undefined,
      revisors_handling_12_table_column_reguleringsbeloeb_plus_minus: "+",
      revisors_handling_12_table_column_reguleringsdato: undefined,
      revisors_handling_12_table_column_mellemvaerende_beloeb: undefined,
      revisors_handling_12_table_column_mellemvaerende_input: undefined,
    },
  ],
  revisors_handling_12_question: undefined,
  revisors_handling_12_alt_2_uddybning: undefined,
  revisors_handling_13_antal_transaktioner_udvalgt_som_stikproeve: undefined,
  revisors_handling_13_question: undefined,
  revisors_handling_13_question_alt_2_uddybning_table: [
    {
      id: guid(),
      revisors_handling_13_question_alt_2_uddybning_table_column_begrundelse:
        undefined,
      revisors_handling_13_question_alt_2_uddybning_table_column_beloeb:
        undefined,
      revisors_handling_13_question_alt_2_uddybning_table_column_bilagsnummer:
        undefined,
      revisors_handling_13_question_alt_2_uddybning_table_column_dato:
        undefined,
    },
  ],
  revisors_handling_14_question: undefined,
  revisors_handling_14_alt_2_uddybning: undefined,
  revisors_handling_15_question: undefined,
  revisors_handling_15_alt_2_uddybning: undefined,
  revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve: undefined,
  revisors_handling_16_question: undefined,
  revisors_handling_16_question_alt_2_uddybning_table: [
    {
      id: guid(),
      revisors_handling_16_question_alt_2_uddybning_table_column_fakturabeloeb:
        undefined,
      revisors_handling_16_question_alt_2_uddybning_table_column_fakturadato:
        undefined,
      revisors_handling_16_question_alt_2_uddybning_table_column_fakturanr:
        undefined,
      revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_begrundelse:
        undefined,
      revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_nr:
        undefined,
      revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_dato:
        undefined,
      revisors_handling_16_question_alt_2_uddybning_table_column_modtager_navn_cvr:
        undefined,
      revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_beloeb:
        undefined,
      revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_modtager_navn_cvr:
        undefined,
    },
  ],
  revisors_oevrige_oplysninger_kundeforhold_accepteret_dato: undefined,
  revisors_oevrige_oplysninger_arbejsdomraade_checkbox_revision_af_aarsregnskab: false,
  revisors_oevrige_oplysninger_arbejsdomraade_checkbox_udvidet_gennemgang_af_aarsregnskab: false,
  revisors_oevrige_oplysninger_arbejsdomraade_checkbox_review_af_aarsregnskab: false,
  revisors_oevrige_oplysninger_arbejsdomraade_checkbox_assistance_med_regnskabsopslilling_af_aarsregnskab: false,
  revisors_oevrige_oplysninger_arbejsdomraade_checkbox_bogfoering: false,
  revisors_oevrige_oplysninger_revisors_navn: undefined,
  revisors_oevrige_oplysninger_adr_postnr_by: undefined,
  revisors_oevrige_oplysninger_adr_vej_husnr: undefined,
  revisors_oevrige_oplysninger_cvrnr: undefined,
  revisors_oevrige_oplysninger_firmanavn: undefined,
  revisors_oevrige_oplysninger_revisor_type: undefined,
};
